import React, { useEffect, useState } from "react";
import ShareHoldersRegistration from "./ShareHoldersRegistration";
import Layout from "../../Layout";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";
import { useLocation, useParams } from "react-router-dom";
import useShareHolders from "./useShareHolders";

const EditShareHolders = () => {
  const { id } = useParams();
  const location = useLocation();
  const { rowData: shareholder } = location.state || {};

  const { isBtnLoading, setIsBtnLoading } = useShareHolders();

  return (
    <>
      <Layout
        crumbs={[
          { label: "My Entities", url: "/entities" },
          {
            label: (
              <>
                {shareholder?.entityData?.name} (
                <ReactCountryFlag
                  countryCode={shareholder?.entityData?.country}
                  svg
                  className=""
                />{" "}
                {getName(shareholder?.entityData.country || "")})
              </>
            ),
            id: "entity",
            url: `/entity/${shareholder?.entityData?.id}/dashboard`,
          },
          {
            label: "Directors & Shareholders",
            id: "appointments-ownership",
            url: `/entity/${shareholder?.entityData?.id}/share-holders`,
          },
          {
            label: `Edit ${[shareholder?.first_name, shareholder?.legal_name].filter(Boolean).join(" ")}`,
            id: "edit-shareholder",
          },
        ]}
      >
        <ShareHoldersRegistration
          isBtnLoading={isBtnLoading}
          setIsBtnLoading={setIsBtnLoading}
        />
      </Layout>
    </>
  );
};

export default EditShareHolders;
